// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const copyPropertiesExcludeNullsAndGetters = (target: any, source: any) => {
    Object.keys(source).forEach(key => {
        const keyInTarget = Object.getOwnPropertyDescriptor(target, key);
        if (
            source[key] !== null &&
            source[key] !== undefined &&
            (!keyInTarget || (keyInTarget && keyInTarget.configurable))
        ) {
            target[key] = source[key];
        }
    });
};
